<template>

  <app-layout title="Смартфоны/Планшеты">

    <div
      class="buymodal">
      <h2
        v-if="model"
        class="buymodal-title">
        Заявка №{{ model.btag }}
      </h2>
      <div
        class="buymodal-block">

        <buymodal-header
          :headers="headers" />

        <transition
          name="slide-left"
          mode="out-in">

          <div
            class="buymodal-block__loader"
            v-if="loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <div><br></div>
            <div>Ожидайте, происходит определение устройства! Процесс может занять до 3х минут</div>
          </div>
          <div
            class="buymodal-block__loader"
            v-if="calculation">
            <v-progress-circular
              :size="70"
              :width="7"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <div><br></div>
            <div>Ожидайте, происходит оценка устройства! Процесс может занять некоторое время</div>
          </div>

          <screen-one
            v-if="!loading && headers[0].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-two
            v-if="!loading && headers[1].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-three
            v-if="!loading && headers[2].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-four
            v-if="!loading && headers[3].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

        </transition>

      </div>
    </div>

    <refuse-modal
      @cancel="cancel" />

    <icloud-error />

  </app-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import AppLayout from '../components/AppLayout.vue';
import BuymodalHeader from './components/AppleWatch/BuymodalHeader';

import ScreenOne from './components/BuyPhones/Screens/ScreenOne';
import ScreenTwo from './components/BuyPhones/Screens/ScreenTwo';
import ScreenThree from './components/BuyPhones/Screens/ScreenThree';
import ScreenFour from './components/BuyPhones/Screens/ScreenFour';

import RefuseModal from '@/components/Modals/RefuseModal';
import IcloudError from '@/components/Modals/IcloudError';

export default {
  name: 'buy-phones',
  components: {
    AppLayout,
    BuymodalHeader,
    ScreenOne,
    ScreenTwo,
    ScreenThree,
    ScreenFour,
    RefuseModal,
    IcloudError,
  },
  data() {
    return {
      headers: [
        { name: 'Определение устройства', screenWin: true, active: true, },
        { name: 'Расчет стоимости выкупа', screenWin: false, active: false, },
        { name: 'Ввод данных клиента', screenWin: false, active: false, },
        { name: 'Подтверждение выкупа', screenWin: false, active: false, },
      ],
    }
  },
  created() {
    this.RESET_PHONES();
    const { params } = this.$route;
    if (params && params.btag ) {
      (async () => {
        await this.getOrder({ btag: params.btag });
        this.headers.map((item, i) => {
          item.screenWin = false;
          if (i <= 2) {
            item.active = true;
          }
          if (i == 2) {
            item.screenWin = true;
          }
        })
      })()
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'loading']),
  },
  methods: {
    ...mapActions('buyphones', ['cancelModel', 'searchModel', 'getOrder']),
    ...mapMutations('buyphones', ['RESET_PHONES']),
    ...mapMutations('layout', ['SET_REFUSE_MODAL']),

    leave() {
      this.SET_REFUSE_MODAL({ bg: true, modal: true });
    },

    async cancel(data) {
      const response = await this.cancelModel({
        btag: this.model.btag,
        refuseId: data.id,
      });
      this.RESET_PHONES();
      this.headers.map(item => {
        item.screenWin = false;
        item.active = false;
      })
      this.headers[0].screenWin = true;
      this.headers[0].active = true;
    },

    changeScreen(data) {
      const type = data.type;
      const id = data.id;
      let num = 0;

      if (type == 'next') {
        num = id + 1;
        this.headers[num].active = true;
      } else if (type == 'prev') {
        num = id - 1;
        this.headers[id].active = false;
      }

      this.headers[id].screenWin = false;
      this.headers[num].screenWin = true;
    },
  }
};
</script>

<style lang="sass">
  @import '@/styles/views/buyphones.sass'
</style>
